import {DataListContainerDefProps} from "../DataListContainer/defProps";

export const dropDownTitleStr = 'Drop Down Title';
export const DropDownDefProps = {
  dropDownTitle: dropDownTitleStr,
  dropDownOptions: DataListContainerDefProps.itemsList
};